import React, { Component } from 'react';
import AnimateHeight from 'react-animate-height';
import PlusIcon from '../../../../../images/icons/plus-bold.svg';
import styles from './ProofTester.module.sass';
import ClickableDiv from '../../../../ui_kit/clickable_div/ClickableDiv';

class ProofTester extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isActive: false,
    };
  }

  toggleActive = () => {
    this.setState((prevState) => ({
      isActive: !prevState.isActive,
    }));
  };

  render() {
    const { isActive } = this.state;

    return (
      <div className={styles['proof-tester-container']}>
        <ClickableDiv onClick={this.toggleActive} className={styles.title}>
          <img src={PlusIcon} alt="plus" />
          <span> Includes Proof Tester </span>
        </ClickableDiv>
        <AnimateHeight className={styles.content} duration={400} height={isActive ? 'auto' : 0}>
          <div className={styles.text}>
            If you’re satisfied, keep the full size.
            <br />
            If not, return it unopened, free of charge.
          </div>
          <a href="/pages/proof_tester">Learn more about Proof Tester</a>
        </AnimateHeight>
        <ClickableDiv onClick={this.toggleActive} className={styles.what}>
          { isActive ? 'Hide' : 'What is it?' }
        </ClickableDiv>
      </div>
    );
  }
}

export default ProofTester;
